export default __webpack_public_path__ + "static/media/15.fe020954.jpg";